import(/* webpackMode: "eager", webpackExports: ["JournalView"] */ "/vercel/path0/ui/components/app/JournalView.tsx");
